"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAll = findAll;
exports.getSummary = getSummary;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
var BASE_URl = process.env.VUE_APP_BASE_ORDER_API;
function findAll(listQuery) {
  return (0, _request.default)({
    baseURL: BASE_URl,
    url: "/orderTransport",
    method: "get",
    params: listQuery
  });
}
function getSummary(listQuery) {
  return (0, _request.default)({
    baseURL: BASE_URl,
    url: "/orderTransport/summary",
    method: "get",
    params: listQuery
  });
}
function update(orderId, data) {
  return (0, _request.default)({
    baseURL: BASE_URl,
    url: "/orderTransport/".concat(orderId, "/update"),
    method: "post",
    data: data
  });
}